import React from 'react';
import { useEffect, useState } from 'react';
import './styles.scss';

interface AnimatedCounterProps {
  number: string;
  unit: string;
}

const AnimatedCounter: React.FC<AnimatedCounterProps> = ({ number, unit }) => {
  const [oldNumber, setOldNumber] = useState('');
  const [result, setResult] = useState<Array<Array<string | number>> | null>(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const maxDigits = 12;

  function generateArray(from: string, to: string) {
    const fromNum = parseInt(from);
    const toNum = parseInt(to);
    const result = [];
    let j = fromNum;
    while (j !== toNum) {
      result.push(j);
      j = (j + 1) % 10;
    }
    result.push(toNum);
    return result;
  }

  const calcResult = () => {
    const oldNumberArray = oldNumber.split('').reverse();
    const newNumberArray = number.split('').reverse();
    const oldNumberLength = oldNumberArray.length;
    const newNumberLength = newNumberArray.length;
    const result = [];
    for (let i = 0; i < maxDigits; i++) {
      if (i == 2) {
        result.push(['.']);
        continue;
      }
      if (i < oldNumberLength && i < newNumberLength) {
        const generatedArray = generateArray(oldNumberArray[i], newNumberArray[i]);
        result.push(generatedArray);
        continue;
      }
      if (i < newNumberLength) {
        const generatedArray = generateArray('1', newNumberArray[i]);
        result.push(['', ...generatedArray]);
        continue;
      }
    }
    setResult(result.reverse());
    setIsAnimating(true);
    setOldNumber(number);
    setTimeout(() => {
      setIsAnimating(false);
    }, 2000);
  };

  useEffect(() => {
    calcResult();
  }, [number]);

  return (
    <div className="animated-counter">
      <div className="counter-container">
        {isAnimating
          ? result?.map((item, index) => (
              <span
                key={index}
                className={`digit-wrapper 
                  ${item[0] === '.' ? 'dot' : ''}
                  ${item[0] === unit ? 'unit' : ''}
                `}
              >
                {item?.map((digit, nestedIndex) => (
                  <div key={nestedIndex}>{digit}</div>
                ))}
              </span>
            ))
          : number.split('').map((item, index) => (
              <span key={index} className={`digit-wrapper no-anim ${item === '.' ? 'dot' : ''}`}>
                <div>{item}</div>
              </span>
            ))}
        <span className="digit-wrapper no-anim unit">
          <div>{unit}</div>
        </span>
      </div>
    </div>
  );
};

export default AnimatedCounter;
